import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import './FullWidthBlock.scss';
import '../styles/OmturGrid.scss';
import ContentWrapper from './ContentWrapper';

export const FullWidthBlock: React.FC<{
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  backgroundColor?: CSSProperties['backgroundColor'];
  gridColumn?: string;
}> = ({ children, className, style, gridColumn, backgroundColor }) => {
  return (
    <ContentWrapper
      className={classNames('full-width-block', className)}
      style={{ gridColumn, ...style }}
    >
      <div
        className="full-width-block__background"
        style={{ backgroundColor }}
      />
      {children}
    </ContentWrapper>
  );
};
